import { has, get } from 'lodash-es';

// TODO: This will have to be migrated to Vue 3 when we get the
// composition API in place.
export function mapInertiaProps(props) {
  const mapped = {};
  // Use a closure that returns a function expression so that
  // we can easily get access to `this`.
  const mapProp = (propKeyOrFunction) =>
    function mappedSharedProp() {
      const pageProps = this.$page.props || {};

      // Allow passing in a function that accepts the whole `$page`
      // object as an argument, and returns the value it wants.
      if (typeof propKeyOrFunction === 'function') {
        return propKeyOrFunction.call(this, pageProps);
      }

      // Make sure that we catch possible "errors" in development
      // by erroring out in development to the console.
      if (
        // TODO: Move this to `import.meta.env.DEV` when we update to Vite.
        !import.meta.env.PROD &&
        !has(pageProps, propKeyOrFunction)
      ) {
        console.error(`[Inertia] Page prop not found: ${propKeyOrFunction}`);

        return;
      }

      return get(pageProps, propKeyOrFunction);
    };

  if (Array.isArray(props)) {
    props.forEach((key) => {
      mapped[key] = mapProp(key);
    });
  } else {
    Object.entries(props).forEach(([renamedPropKey, realPropKey]) => {
      mapped[renamedPropKey] = mapProp(realPropKey);
    });
  }

  return mapped;
}

/**
 * Helper mixin to watch for "flash" notices & alerts
 * shared from the RoR side of things.
 *
 * NOTE: This should in fact live in the Layout component
 * of the app, but because we are not using Inertia
 * to its full potential we have to rely on this
 * helper mixin to do the job.
 */
export const InertiaFlashWatcher = {
  computed: {
    ...mapInertiaProps(['flash']),
  },
  watch: {
    flash: {
      deep: true,
      handler(flash = {}) {
        // TODO: With the new Design System, we could
        // essentially make this a Toast with correct
        // positioning and styling.
        if (flash.alert || flash.notice) {
          this.$appMessage(flash.alert || flash.notice);
        }
      },
    },
  },
};

/**
 * Helper mixin to watch for "start" & "finish" Inertia events
 * in order to track a loading flag.
 *
 * TODO: Find a way to differentiate a navigation via link, and
 * a form submission for example; as right now they both trigger
 * this event.
 */
export const InertiaLoadingWatcher = {
  data: () => ({ loading: false, loadingStartedAt: null }),
  mounted() {
    this.$inertia.on('start', () => {
      this.loading = true;
      this.loadingStartedAt = new Date();
    });

    this.$inertia.on('finish', () => {
      const finishedAt = new Date();
      const timeDiff = finishedAt - this.loadingStartedAt;

      this.loadingStartedAt = null;

      setTimeout(() => {
        this.loading = false;
      }, Math.max(400 - timeDiff, 0));
    });
  },
};
